<template>
  <div id="app">
    <router-view />
    <el-dialog
      :title="$vi18n('$i18n# 验证身份 #i18n$')"
      append-to-body
      :visible.sync="emailLoginDialog.visible"
      destroy-on-close
      width="600px"
    >
      <EmailLoginForm :data="emailLoginDialog.data" @loginSuccess="handleLoginSuccess"></EmailLoginForm>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EmailLoginForm from '@/components/EmailLoginForm';
import { isInGame, neatedLoginUserInfo, setUserInfoInStorage } from './utils';
export default {
  components: {
    EmailLoginForm
  },
  computed: {
    ...mapState(['emailLoginDialog']),
  },
  mounted() {
    document.title = this.$vi18n('$i18n# 创作者服务中心 #i18n$')
  },
  methods: {
    handleLoginSuccess(data) {
      this.$store.commit('CHANGE_EMAIL_LOGIN_DIALOG', { data: null, visible: false });
      const userInfo = setUserInfoInStorage(neatedLoginUserInfo(data));
      window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
      sessionStorage.removeItem('setible');
      sessionStorage.removeItem('token2');
      this.$router.push('/', () => location.reload());
    }
  }
};
</script>

<style lang="scss">
body {
  background-color: #f5f5f5;
  min-width: 1280px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-picker-panel {
  .el-month-table td.today .cell {
    color: #606266;
    font-weight: 400;
  }
}
.content-wrapper {
  background: #fff;
  border-radius: 8px;
  width: 1056px;
  padding: 33px;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
}
.el-message {
  z-index: 3000 !important;
}
</style>
